import {
  FilterOptionSelectedValue,
  FilterSelectedValue,
  OPERATIONS,
  VALUE_MATCH,
} from '../../../../../hooks/filters/interfaces/filter-selected-value.interface';

export const getCompactViewSelection = (
  filterId: string,
  selectAll: boolean | undefined | string,
  values: FilterOptionSelectedValue[],
) => {
  const selection: FilterSelectedValue = {
    id: filterId,
    values,
    matchStrategy: {
      operation: OPERATIONS.AND,
      valueMatch:
        selectAll === true
          ? VALUE_MATCH.EXCLUDE_MULTIPLE
          : VALUE_MATCH.MULTIPLE,
      groupName: 'group-1',
    },
  };
  return selection;
};
